<div *ngIf="data && countryCodes" class="charts-container">
<!--  <app-help-icon-button [code]="this.countryCategory === 'putonmarket' ? 'kfcharts.Country.PutOnMarket.BenchmarkByYear' : 'kfcharts.Country.Collected.BenchmarkByYear'" align="end" style="display: block"></app-help-icon-button>-->
  <div [chart]="chart"></div>
  <p>Last modified date: {{data[0]?.lastModifiedDate | date: 'dd/MM/yyyy, h:mm a'}}</p>
  <div style="display: flex">
    <p>{{textBelow}}</p>
    <mat-icon *ngIf="isAdmin" matTooltip="Edit help text" color="primary" class="pointer" (click)="editTextBelow()" style="margin-left: 4px">edit</mat-icon>
  </div>
</div>
